module.exports = __webpack_public_path__ + "img/bg27.4baf70a0.png";